<template>
  <div>
    <div class="card__header">
      <p class="card__title">Oh no…</p>
      <div class="card__subtitle">
        <p class="body">
          The person you wish to send a gift to is not in our delivery zone yet.
        </p>
      </div>
    </div>
    <div class="card__actions">
      <div class="buttons buttons--wrap">
        <button type="submit" class="button button--md button--grey" v-on:click="reload()">Back to dashboard</button>
        <button type="submit" class="button button--md button--secondary" v-on:click="$parent.step = 'ADDRESS'">Try another address</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    reload() {
      window.location.reload();
    },
  }
}
</script>